

import React, { Component } from 'react';
import qs from 'qs';

if( !location ) {
  var location = window.location;

  // var location = {
  //   "href": "https://react-instantsearch.netlify.app/examples/next",
  //   "origin": "https://react-instantsearch.netlify.app",
  //   "protocol": "https:",
  //   "host": "react-instantsearch.netlify.app",
  //   "hostname": "react-instantsearch.netlify.app",
  //   "port": "",
  //   "pathname": "/examples/next",
  //   "search": "",
  //   "hash": ""
  // }
  
}

const updateAfter = 700;

const routeStateDefaultValues = {
  query: '',
  page: '1',
  manufacturer: undefined,
  model: undefined,
  longIcYear: undefined,
  price: '',
  hasPartImages: 'false',
  sortBy: 'nippon-parts',
  hitsPerPage: '20',
};

const searchStateToURL = searchState => {
  const routeState = {
    query: searchState.query,
    page: String(searchState.page),
    manufacturer: searchState.refinementList && searchState.refinementList.manufacturer,
    model: searchState.refinementList && searchState.refinementList.model,
    longIcYear: searchState.refinementList && searchState.refinementList.longIcYear,
    price:
      searchState.range &&
      searchState.range.price &&
      `${searchState.range.price.min || ''}:${searchState.range.price.max ||
        ''}`,
        hasPartImages:
      (searchState.toggle && String(searchState.toggle.hasPartImages)) ||
      undefined,
    sortBy: searchState.sortBy,
    hitsPerPage:
      (searchState.hitsPerPage && String(searchState.hitsPerPage)) || undefined,
  };

  const { protocol, hostname, port = '', pathname, hash } = location;
  const portWithPrefix = port === '' ? '' : `:${port}`;
  const urlParts = location.href.match(/^(.*?)\/search/);
  const baseUrl =
    (urlParts && urlParts[0]) ||
    `${protocol}//${hostname}${portWithPrefix}${pathname}search`;

  const categoryPath = '';
  const queryParameters = {};

  if (routeState.query && routeState.query !== routeStateDefaultValues.query) {
    queryParameters.query = encodeURIComponent(routeState.query);
  }
  if (routeState.page && routeState.page !== routeStateDefaultValues.page) {
    queryParameters.page = routeState.page;
  }
  if (
    routeState.manufacturer &&
    routeState.manufacturer !== routeStateDefaultValues.manufacturer
  ) {
    queryParameters.manufacturer = routeState.manufacturer.map(encodeURIComponent);
  }
  if (
    routeState.model &&
    routeState.model !== routeStateDefaultValues.model
  ) {
    queryParameters.model = routeState.model.map(encodeURIComponent);
  }
  if (
    routeState.longIcYear &&
    routeState.longIcYear !== routeStateDefaultValues.longIcYear
  ) {
    queryParameters.longIcYear = routeState.longIcYear.map(encodeURIComponent);
  }
  if (routeState.price && routeState.price !== routeStateDefaultValues.price) {
    queryParameters.price = routeState.price;
  }
  if (
    routeState.hasPartImages &&
    routeState.hasPartImages !== routeStateDefaultValues.hasPartImages
  ) {
    queryParameters.hasPartImages = routeState.hasPartImages;
  }
  if (
    routeState.sortBy &&
    routeState.sortBy !== routeStateDefaultValues.sortBy
  ) {
    queryParameters.sortBy = routeState.sortBy;
  }
  if (
    routeState.hitsPerPage &&
    routeState.hitsPerPage !== routeStateDefaultValues.hitsPerPage
  ) {
    queryParameters.hitsPerPage = routeState.hitsPerPage;
  }

  const queryString = qs.stringify(queryParameters, {
    addQueryPrefix: true,
    arrayFormat: 'repeat',
  });

  return `${baseUrl}/${categoryPath}${queryString}${hash}`;
};

const urlToSearchState = location => {
  const pathnameMatches = location.pathname.match(/search\/(.*?)\/?$/);
  const queryParameters = qs.parse(location.search.slice(1));
  const {
    query = '',
    page = 1,
    manufacturer = [],
    model = [],
    longIcYear = [],
    hasPartImages,
    price,
    hitsPerPage,
    sortBy,
  } = queryParameters;
  // `qs` does not return an array when there's a single value.
  const allManufacturers = Array.isArray(manufacturer) ? manufacturer : [manufacturer].filter(Boolean);
  const allModels = Array.isArray(model) ? model : [model].filter(Boolean);
  const allYears = Array.isArray(longIcYear) ? longIcYear : [longIcYear].filter(Boolean);

  const searchState = { range: {} };

  if (query) {
    searchState.query = decodeURIComponent(query);
  }
  if (page) {
    searchState.page = page;
  }
  if (allManufacturers.length) {
    searchState.refinementList = {
      manufacturer: allManufacturers.map(decodeURIComponent),
    };
  }
  if (allYears.length) {
    searchState.refinementList = {
      longIcYear: allYears.map(decodeURIComponent),
    };
  }
  if (allModels.length) {
    searchState.refinementList = {
      model: allModels.map(decodeURIComponent),
    };
  }
  if (price) {
    const [min, max = undefined] = price.split(':');
    searchState.range.price = {
      min: min || undefined,
      max: max || undefined,
    };
  }
  if (hasPartImages) {
    searchState.toggle = {
      hasPartImages: Boolean(hasPartImages),
    };
  }
  if (sortBy) {
    searchState.sortBy = sortBy;
  }

  if (hitsPerPage) {
    searchState.hitsPerPage = hitsPerPage;
  }

  return searchState;
};

const withURLSync = App =>
  class WithURLSync extends Component {
    state = {
      searchState: urlToSearchState(window.location),
    };

    componentDidMount() {
      window.addEventListener('popstate', this.onPopState);
    }

    componentWillUnmount() {
      clearTimeout(this.debouncedSetState);
      window.removeEventListener('popstate', this.onPopState);
    }

    onPopState = ({ state }) =>
      this.setState({
        searchState: state || {},
      });

    onSearchStateChange = searchState => {
      clearTimeout(this.debouncedSetState);

      this.debouncedSetState = setTimeout(() => {
        window.history.pushState(
          searchState,
          null,
          searchStateToURL(searchState)
        );
      }, updateAfter);

      this.setState({ searchState });
    };

    render() {
      const { searchState } = this.state;

      return (
        <App
          {...this.props}
          searchState={searchState}
          onSearchStateChange={this.onSearchStateChange}
          createURL={searchStateToURL}
        />
      );
    }
  };

export default withURLSync;
